import find from "lodash/find";
import templateUrl from "./advertisements-main.html";

export const advertisementsMainComponent = {
  templateUrl,
  bindings: {
    title: "@",
    details: "<",
    advertisementPages: "<",
  },
  controller: class AdvertisementsMainComponent {
    constructor(
      $state,
      $stateParams,
      toastr,
      ApiService,
      AdvertisementsService
    ) {
      "ngInject";

      this.$state = $state;
      this.$stateParams = $stateParams;
      this.toastr = toastr;
      this.imageUrl = {};
      this.ApiService = ApiService;
      this.disableButttonSubmit = false;
      this.AdvertisementsService = AdvertisementsService;
    }
    _incrementDay(date) {
      return new Date(date.getTime() + 24 * 60 * 60 * 1000);
    }
    $onInit() {
      this.selectedPageList = [];
      this.cropModalDetails = {
        windowClass: "modal-advertisement-window",
      };
      this.showAdvertisement = false;
      this.showInWeeklyNewsletter = false;
      if (!this.details) {
        this.details = {
          fileUuid: {},
          isActive: true,
          startDate: new Date(),
        };
      } else {
        this.details.startDate = new Date(this.details.startDate);
        this.details.endDate = this.details.endDate
          ? new Date(this.details.endDate)
          : null;
      }
      this.selectedAdvertisementPageId =
        this.details && this.details.advertisementPageName
          ? this.getSelectedAdvertisementPageId(this.details)
          : null;
      if (this.details && this.details.fileUuid) {
        this.imageUrl.desktop = this.ApiService.getImageUrl(
          this.details.fileUuid.desktop
        );
        this.imageUrl.mobile = this.ApiService.getImageUrl(
          this.details.fileUuid.mobile
        );
        this.imageUrl.tablet = this.ApiService.getImageUrl(
          this.details.fileUuid.tablet
        );
      }
      this.datePickerStartDate = {
        disablePreviousDates: true,
        maxDate: this.details.endDate
          ? this._incrementDay(this.details.endDate)
          : null,
        selectedDate: this.details.startDate || new Date(),
      };
      this.datePickerEndDate = {
        disablePreviousDates: true,
        isRequired: false,
        selectedDate: this.details.endDate || null,
      };
    }
    onChangeShowAdvertisement() {
      this.showAdvertisement = !this.showAdvertisement;
    }
    onChangeShowInWeeklyNewsletter() {
      this.showInWeeklyNewsletter = !this.showInWeeklyNewsletter;
    }
    onStartDateChange(date) {
      this.details.startDate = date.selectedDate;
    }
    onEndDateChange(date) {
      this.details.endDate = date.selectedDate;
      if (
        date.selectedDate &&
        this.datePickerStartDate.selectedDate > date.selectedDate
      ) {
        this.details.startDate = date.selectedDate;
      }
      // increment day by 1, else the single day selection
      // wont be possible
      const maxStartDate = date.selectedDate
        ? this._incrementDay(date.selectedDate)
        : null;
      this.datePickerStartDate = {
        disablePreviousDates: true,
        maxDate: date.selectedDate ? maxStartDate : null,
        selectedDate: this.details.startDate,
      };
    }
    getSelectedAdvertisementPageId(data) {
      const result = find(
        this.advertisementPages,
        ({ displayName }) => displayName === data.advertisementPageName
      );
      return result.advertisementPageId;
    }
    onImageUploadInProgress() {
      this.disableButttonSubmit = true;
    }
    onImageUpload({ details: { uuid } }, bannerType) {
      this.disableButttonSubmit = false;
      this.imageUrl[bannerType] = this.ApiService.getImageUrl(uuid);
      this.details.fileUuid[bannerType] = uuid;
    }
    onRemoveImage(bannerType) {
      this.imageUrl[bannerType] = null;
      this.details.fileUuid[bannerType] = null;
    }
    onSubmit() {
      if (this.details) {
        this.details.advertisementPageId = this.selectedAdvertisementPageId;
        if (
          this.details.fileUuid &&
          (this.details.fileUuid.desktop ||
            this.details.fileUuid.mobile ||
            this.details.fileUuid.tablet)
        ) {
          this.disableButttonSubmit = true;
          if (!this.$stateParams.id) {
            // edit
            this.AdvertisementsService.createAdvertisement(this.details)
              .then((_) => {
                this.toastr.success("Advertisement Created Successfully.");
                this.$state.go("advertisements");
              })
              .catch((error) => {
                this.disableButttonSubmit = false;
                this.toastr.error(error.data.errors.message);
              });
          } else {
            // add
            this.AdvertisementsService.updateAdvertisement(this.details)
              .then((_) => {
                this.toastr.success("Advertisement Updated Successfully.");
                this.$state.go("advertisements");
              })
              .catch((error) => {
                this.disableButttonSubmit = false;
                this.toastr.error(error.data.errors.message);
              });
          }
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/advertisements/advertisements-main/advertisements-main.component.js